import { useCallback } from 'react'

import { createBookingFieldEnteredEvent } from '@/events/BookingFieldEntered'
import { hashValue, normaliseValue } from '@/helpers/AnalyticsSegmentHelper'
import { TrackBookingFieldEnteredInput } from '@/types'
import { useAnalytics } from './AnalyticsHook'

export const useBookingFieldEntered = () => {
  const analytics = useAnalytics()

  const trackBookingFieldEntered = useCallback(
    ({ label, value, section, fieldTitle, fieldType }: TrackBookingFieldEnteredInput) => {
      // Removes whitespace from both ends of the value
      const removedSpacesValue = normaliseValue(value)

      // Get value length
      const inputLength = removedSpacesValue.length

      // Hash values just in case it contains PIIs
      const hashPIIValue = hashValue(removedSpacesValue)

      const event = createBookingFieldEnteredEvent({
        label: label,
        value: hashPIIValue,
        inputLength: inputLength,
        section: section,
        fieldTitle: fieldTitle,
        fieldType: fieldType,
      })

      analytics.trackEvent(event)
    },

    [analytics]
  )

  return trackBookingFieldEntered
}
